import { HOME } from '../actions';

const initialState = {
    heroSlider: [],
    popupPromotion: [],
    newArrival: null,
    containerHeight: '100vh',
    containerMinHeight: '100vh'
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case HOME.GET_NEW_ARRIVAL:
            return { ...state, newArrival: payload };

        case HOME.GET_HERO_SLIDER:
            return { ...state, heroSlider: payload };

        case HOME.SET_HEIGHT_OF_CONTAINER:
            return { ...state, containerHeight: payload }

        case HOME.SET_MIN_HEIGHT_OF_CONTAINER:
            return { ...state, containerMinHeight: payload }
        
        case HOME.GET_POPUP_PROMOTION:
        return { ...state, popupPromotion: payload }

        default:
            return state;
    }
};
